import { useSearchParams } from 'react-router-dom';
import { useUser } from '../authorization/use-user.ts';
import { useCartProductsStore } from '../cart/use-cart-products.store.ts';
import { useFavoriteProductsStore } from '../favorite/use-favorite-products.store.ts';
import { useEffect } from 'react';

export function useRemoteStoreValidator() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isUseCache, isAuthenticated } = useUser();
  const cartStore = useCartProductsStore({ isUseCache });
  const favoriteProductsStore = useFavoriteProductsStore({ isUseCache });

  const isValidate = searchParams.get('store') === 'validate';
  useEffect(() => {
    if (isValidate && isAuthenticated) {
      cartStore.validateRemove();
      favoriteProductsStore.validateRemove();
      searchParams.delete('store');
      setSearchParams(searchParams);
    } else {
      favoriteProductsStore.init();
      cartStore.init();
    }
  }, [isAuthenticated, isValidate]);
}
